import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, Validators } from '@angular/forms';
import { MatomoTracker } from 'ngx-matomo';
import { UntypedFormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { URLConst } from 'src/app/shared/const/url.const';


@Component({
  selector: 'app-WmsmRegisterVendor',
  templateUrl: './wmsmRegisterVendor.component.html',
  styleUrls: ['./wmsmRegisterVendor.component.scss'],

})

export class WmsmRegisterVendor extends BaseComponent implements OnInit {
  SiteList:any;
  CompanyCodeList: any;
  loading:boolean = false;
  validateForm!: UntypedFormGroup;
  VendorGroupList: any;

  constructor(
    private webApiService: WebApiService,
    private Environment: EnvironmentconfigService,
    private matomotracker: MatomoTracker,
    private messageService: NzMessageService,
    private fb: FormBuilder) { super() }


  ngOnInit() {
    this.validateForm = this.fb.group({
      companyCode: [[], [Validators.required]],
      vendorCode: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      email: ['', [Validators.required, Validators.pattern("^[-.-_A-Za-z0-9]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$")]],
      phoneNumber: ['', [Validators.required]],
      Site: ['', [Validators.required]],
      vendorGroup: [[], [Validators.required]],
      vendorContact: [[], [Validators.required]]
    });


    // this.LayoutComponent.geturl()
    this.getSiteList();
    this.getVendorGroup();
    this.matomotracker.trackPageView("一般性功能設置")
    this.matomotracker.trackEvent("一般性功能設置", "賬號申請", "Transation", 1);
  }

  submitForm(): void {
    if (this.validateForm.valid) {

      const site = this.validateForm.controls['Site'].value;

      this.loading = true;
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.registerVendor.url}`;
      const params = {
        data: {
          VendorGroup: this.validateForm.controls['vendorGroup'].value,
          CompanyCodeList: this.validateForm.controls['companyCode'].value,
          VendorCode: this.validateForm.controls['vendorCode'].value.replace(" ", ""),
          Person: this.validateForm.controls['vendorContact'].value.replace(" ", ""),
          MobileNumber: this.validateForm.controls['email'].value.replace(" ", ""),
          Email: this.validateForm.controls['email'].value.replace(" ", ""),
          Telephone: this.validateForm.controls['phoneNumber'].value.replace(" ", ""),
          SiteName: site.siteName,
          SiteNo: site. siteNo,
        },
      };

      this.webApiService.doPost(url, params).subscribe(
        (res) => {
          if (res.data != null && res.data.length > 0 && res.status == '200') {
            this.ngOnInit()
            this.messageService.success(res.msg);
          } else {
            this.messageService.error(res.msg);
          }
          this.loading = false;
        },
        (error) => {
          this.messageService.error(error.msg);
          this.loading = false;
        }
      );
    } else {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }



  getVendorGroup() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorType.url}`;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if(res.length>0){
          this.VendorGroupList = res
        }
      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }


  getSiteList()
  {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteList.url}`;
    const params = {
    };
    this.webApiService.doGet(url).subscribe(
      (res) => {
        if(res.status=='200'){
          this.SiteList=res.data;
        }
        else
        {
          throw new Error('Non-200 status code');
        }

      },
      (error) => {
        this.messageService.error(error.message || 'An error occurred');
      }
    );
  }

  getCompanyCodeList(Site)
  {
    var siteNo = Site.siteNo;
    debugger
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.getCompanyDtoBySiteNo.url}`+'?SiteNo='+siteNo;
    const params = {
    };
    this.webApiService.doGet(url).subscribe(
      (res) => {
        if(res.status=='200'){
          this.CompanyCodeList=res.data;
          console.log(this.CompanyCodeList);
        }
        else
        {
          throw new Error('Non-200 status code');
        }

      },
      (error) => {
        this.messageService.error(error.message || 'An error occurred');
      }
    );
  }



}

